import React from 'react';
import styled from 'styled-components';

import x_coin_img from '../../../assets/white_crown.svg';

export default function PaywallConsTool(props) {


  return (
    <Wrapper>
      <Img src={x_coin_img} alt={'unblur'} />
      <TextSpan>
        {'Unblur'}
      </TextSpan>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 1000px;
  //background: #ff7e55;
  background: linear-gradient(90deg, #9E5EEE -3.26%, #B885F4 91.41%);

  cursor: pointer;

  box-shadow: 6px 5px 21px -6px rgba(0, 0, 0, 0.14);
  -webkit-box-shadow: 6px 5px 21px -6px rgba(0, 0, 0, 0.14);
  -moz-box-shadow: 6px 5px 21px -6px rgba(0, 0, 0, 0.14);

  
  :hover {
    opacity: 0.7;
  }

`;

const TextSpan = styled.div`
  color: white;
`;

const Img = styled.img`
  height: 32px;
  margin-right: 5px;
`;